import { render } from "./FrontPage.vue?vue&type=template&id=188dd8da&ts=true"
import script from "./FrontPage.vue?vue&type=script&lang=ts"
export * from "./FrontPage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Rogerio\\devel\\pixPrinter\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__